import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form, Message } from 'semantic-ui-react'
// import _find from 'lodash/find';
// import _ from 'lodash';

// import XLSX from 'xlsx';

//utils
import queries from '../../../utils/queries'
import SeguroPermite from '../../../components/funcionales/seguropermite'
import general from '../../../modulos/general';

import mainAju from '../functions/ajustes/mainaju';
// "use strict";

//Ajustes
const DetAjustes = ({elemento}) => {
  return(
    <tr className=''>
      <td className=''>{elemento.linea}</td>
      <td className=''>{elemento.contrato}</td>
      <td className=''>{elemento.concepto}</td>
      <td className='right aligned'>{general.formatNum(elemento.valor.toString())}</td>
    </tr>
  )
};

const ListaAjustes = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetAjustes elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class ProcAdmAjPos extends React.Component {
  state={listAjustes: [], totAjustes: 0,
        permiteUpdate: true, confirmaAct: false, open: false, errors: []}

  nextVal = async (name) => {
    const argsUpd = {
        coleccion: name,
      }
      const response = await this.props.editSeqfindOneAndUpdate({
        variables: argsUpd
      });
      return response.data.editSeqfindOneAndUpdate.seq
  }

  handleChange = async (ev) => {
// console.log(ev.target.name)

    const updState = (listAjustes, totAjustes) => {
      this.setState({listAjustes, totAjustes, errors: []})
    };

    if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"){
      let checkTieneEncab = document.getElementById("checkTieneEncab").checked
      let fileInput = document.getElementById("csv")
      if(fileInput.files.length>0){
        let archcsv = ""
// console.log(fileInput.files[0].name) //Nombre del archivo seleccionado
        let reader = new FileReader();
        reader.onload = function () {
          archcsv = reader.result
          // document.getElementById('out').innerHTML = archcsv;

          //asignar los datos del archivo a archivo
          let archivo = archcsv.toString()
          //guardar en array lines, cada linea del archivo
          let lines = archivo.split(/\n/)
          let numAj = 0, linea = 0, listAjustes = [], totAjustes = 0
          lines.forEach(line => {
            if(line&&(numAj>0||(numAj===0&&!checkTieneEncab))){
              linea += 1
              //crear array de campos para cada linea
              let campos = line.split(";")
              let contrato = campos[0]
              let concepto = campos[1]
              let valor = parseInt(campos[2], 10)
              totAjustes += valor
              listAjustes.push({linea, contrato, concepto, valor})
            }
            numAj += 1
          })
          updState(listAjustes, totAjustes)
        };
        // start reading the file. When it is done, calls the onload event defined above.
        reader.readAsBinaryString(fileInput.files[0]);
      }else{
        this.setState({listAjustes: [], totAjustes: 0, errors: []})
      }
    }
  }

  handleSubmit = async (ev, listAjustes)=>{
      let errors = []
      if(listAjustes.length===0){
        errors.push({path: "Ajustes", message: "No hay ajustes"});
      }
      for(let ii=0; ii<listAjustes.length; ii++){
        let elemento = listAjustes[ii]
        if(!elemento.contrato||!elemento.concepto||!elemento.valor){
          errors.push({path: "Ajustes", message: `Datos inválidos en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}, Concepto: ${elemento.concepto}, Valor: ${elemento.valor}`});
        }

        if(this.props.allClientes.allClientes){
          let {data} = await this.props.allClientes.refetch({contrato: listAjustes[ii].contrato, numDocum: 1327})
          let allClientes = await data.allClientes
          if(allClientes.length===0){
            errors.push({path: "Clientes", message: `Contrato NO existe en línea No. ${elemento.linea} => Contrato: ${elemento.contrato}`});
          }
        }
  
        if(elemento.valor<=0){
          errors.push({path: 'Valor', message: `Línea No. ${elemento.linea} => El valor del ajuste ($${elemento.valor}) no puede ser menor o igual a cero`});
        }
      }

      this.setState({errors})
      if(errors.length===0){
//PROCESO APLICAR AJUSTES
        document.body.style.cursor = 'wait'

        let checkPagoAdel = false

//EL ULTIMO CONTRATO NO DEBE TENER NAS DE UN AJUSTE PORQUE SI TIENE MAS DE UNO,
//CUANDO ENCUENTRE EL PRIMER AJUSTE Y LO COMPARE CON contratoFinProc FINALIZA EL PROCESO
        let iii = 0, contratoFinProc = listAjustes[listAjustes.length-1].contrato, contratoFin = ""

        const startTime = async (listAjustes, allCli, allMovCli, editSeqfindOneAndUpdate, createAjuste,
          createHistClienteMany, createMovClientes, editMovClientes, editCliente, checkPagoAdel) => {
          let clienteSel = {}, lista4 = []

          setTimeout(async ()=>{
            // console.log("paso ajuste")
            if(iii<listAjustes.length){
              let response = await this.props.fecha({
                variables: {}
              });
              const {fechaHoraHoy} = response.data.fecha

              if(allCli){
                let {data} = await allCli.refetch({contrato: listAjustes[iii].contrato, numDocum: 1327})
                let allClientes = await data.allClientes
                clienteSel = allClientes[0]
              }
              if(allMovCli){
                let {data} = await allMovCli.refetch({contrato: listAjustes[iii].contrato, orden: '+_id'})
                let allMovClientes = await data.allMovClientes
                lista4 = allMovClientes
                lista4 = lista4.filter(elemento => elemento.tipo==="C" && elemento.valorTotal!==elemento.valorPagado)
              }
              let tipoAjuste = "AP"
              let contratoAj = await mainAju(tipoAjuste, listAjustes[iii], clienteSel, lista4, editSeqfindOneAndUpdate,
                createAjuste, createHistClienteMany, createMovClientes, editMovClientes, editCliente, fechaHoraHoy, checkPagoAdel)
              contratoFin = contratoAj.contrato

              await startTime(listAjustes, allCli, allMovCli, editSeqfindOneAndUpdate, createAjuste,
                createHistClienteMany, createMovClientes, editMovClientes, editCliente, checkPagoAdel)
// console.log(iii, "contrato ", contratoFin, contratoFinProc)
              if(contratoFin===contratoFinProc){
                
                setTimeout(async () => {
                  this.setState({listAjustes: [], totAjustes: 0, errors: []})
                  document.body.style.cursor = 'default'
                }, 2000)

                // console.log("timeout fin", iii)
              }

              iii += 1
            } 
          }, 200);
        }
        await startTime(listAjustes, this.props.allClientes, this.props.allMovClientes,
                        this.props.editSeqfindOneAndUpdate, this.props.createAjuste,
                        this.props.createHistClienteMany, this.props.createMovClientes,
                        this.props.editMovClientes, this.props.editCliente, checkPagoAdel)

    }
    
    console.log("listooooo")
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false, confirmaAct: false})};
    if(btnPress==="No"){
        this.setState({open: false})
    };
    if(btnPress==="Si"){
        this.setState({confirmaAct: true})
        this.setState({open: false})
        const myBtn = await document.getElementById("btnUpdDel");
        myBtn.click()
    }
  }

  async componentDidUpdate(prevProps){

  }

  render(){
    const {listAjustes, totAjustes, permiteUpdate, confirmaAct, open,
            errors} = this.state;

    let mensaje = "APLICAR AJUSTES"
    let imgIcon = "images/archivo_32.png"

    // let estilos = Object.assign({}, this.props.styles.input, {opacity: 0, cursor: 'pointer'})
    // let estilos = Object.assign({}, this.props.styles.input, {display: "none", cursor: 'pointer'})
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    // let estilos = this.props.styles.input

    return(
      <div>
          <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
              <i className="large plus yellow icon"></i>
              Procesar archivo
          </button>
          <div>
                    <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
                    <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listAjustes):()=>{}}>
                        <div>
                            <div className="ui one column stackable grid">
                                <div className="row container">
                                    <div className="column" style={{width: '100%'}}>
                                      <h1 style={{color: '#2C7744'}}>Procesar archivo de ajustes positivos</h1>
                                    </div>
                                </div>
                            </div>
                            <hr></hr>
                            <hr></hr>
                            <br/>
                            <div className="ui two column stackable grid">
                              <div className="row container">
                                <div className="column" style={{width: '50%'}}>
                                  <label style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                                    Seleccionar archivo CSV...&nbsp;&nbsp;
                                  </label>

                                  <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>

                                  {/* <output id="out" style={estilos1}>
                                      file contents will appear here
                                  </output> */}
                                </div>
                                <div className="column" style={{width: '50%'}}>
                                  <Form.Field>
                                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                                      <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                                              name="checkTieneEncab" onChange={this.handleChange}/>
                                      &nbsp;&nbsp;Tiene encabezados en la primera fila
                                    </p>
                                  </Form.Field>
                                </div>

                              </div>
                            </div>
                            <br/>
                            <hr></hr>
                            <hr></hr>

                            <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                              Totales:  Ajustes:&nbsp;
                              {listAjustes.length}&nbsp;&nbsp;&nbsp;&nbsp;
                              Valor:&nbsp;
                              ${general.formatNum(totAjustes.toString())}
                            </p>

                            <div className="ui one column stackable grid">
                              <div className="row container">
                                <div className="column" style={{width: '100%'}}>
                                  <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                                </div>
                              </div>
                            </div>
                            <hr></hr>

                            {
                                errors.length?<Message negative header="Los siguientes errores:"
                                list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                            }

                            <table id="tablaPagos" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                              <thead className=''>
                                <tr className=''>
                                <th className=''>No.</th>  
                                <th className=''>Contrato</th>
                                <th className=''>Concepto</th>
                                <th className='right aligned'>$ Valor</th>
                                </tr>
                              </thead>
                              <ListaAjustes list={listAjustes}/>
                            </table>
                        </div>

                      </Form>
                    </div>
                </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 1}}}}),
  graphql(queries.query.allMovClientes, {name:'allMovClientes', options: (props) => {return {variables: {contrato: "ABCXYZ", orden: '+_id'}}}}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),

  graphql(queries.mutation.createAjuste, {name:'createAjuste'}),

  graphql(queries.mutation.createHistClienteMany, {name:'createHistClienteMany'}),

  graphql(queries.mutation.createMovClientes, {name:'createMovClientes'}),
  graphql(queries.mutation.editMovClientes, {name:'editMovClientes'}),

  graphql(queries.mutation.editCliente, {name:'editCliente'}),

  graphql(queries.mutation.fecha, {name:'fecha'}),
)(ProcAdmAjPos)
